/**
 * 提供商连通性测试的错误规范化（T15）。
 *
 * 适配器抛出的异常形态不一：HTTP 层统一抛 `ProviderHttpError`（带 code / status），
 * 注册表在 kind 未注册时抛 `ProviderNotRegisteredError`，其余是普通 Error。
 * 这里把它们压成「错误码 + 消息」，让 UI 只负责展示，不再做类型判断。
 */
import { ProviderHttpError, ProviderNotRegisteredError } from '../../core/providers';
import type { ProviderErrorCode } from '../../core/providers/types';

export interface NormalizedProviderError {
  code: ProviderErrorCode;
  message: string;
  status?: number;
}

/** 把任意抛出物规范化成「错误码 + 消息」。 */
export function normalizeProviderError(error: unknown): NormalizedProviderError {
  if (error instanceof ProviderNotRegisteredError) {
    return { code: 'config', message: `未注册的提供商类型：${error.kind}` };
  }
  if (error instanceof ProviderHttpError) {
    return {
      code: error.code,
      message: error.message,
      ...(error.status === undefined ? {} : { status: error.status }),
    };
  }
  if (error instanceof Error) {
    return { code: 'unknown', message: error.message };
  }
  return { code: 'unknown', message: String(error) };
}